"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEntitiesVueObservable = exports.dependChildArray = exports.getArrayObserverConstructor = exports.getArrayObserver = exports.observeArray = exports.getObjectMetaObserverConstructor = exports.getObjectMetaObserver = exports.getEntityObserverConstructor = exports.getEntityObserver = exports.observeEntity = exports.preventVueObservability = exports.getCustomObserverConstructor = void 0;
var vue_1 = require("vue");
var model_js_1 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var model_js_2 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var model_js_3 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var helpers_1 = require("./helpers");
// eslint-disable-next-line no-redeclare
var CustomObserverConstructor = null;
function getCustomObserverConstructor() {
    return CustomObserverConstructor || (CustomObserverConstructor = require("./custom-observer").CustomObserver);
}
exports.getCustomObserverConstructor = getCustomObserverConstructor;
function preventVueObservability(obj) {
    if (obj) {
        if (!(0, helpers_1.hasOwnProperty)(obj, "__ob__")) {
            // Mark the object as "raw" so that Vue won't try to make it observable
            (0, vue_1.markRaw)(obj);
            return true;
        }
        else {
            // Vue's default observability is also bypassed if the object's observer is a subclass of `CustomObserver`
            var CustomObserver = getCustomObserverConstructor();
            return obj.__ob__ instanceof CustomObserver;
        }
    }
}
exports.preventVueObservability = preventVueObservability;
/**
 * Based on Vue's internal `observe()` function. Ensures that the given entity
 * is observable and optionally notes that it is referenced by a component
 * @param entity The entity to observe
 * @param asRootData The entity is referenced as a component's data
 */
function observeEntity(entity, asRootData) {
    if (asRootData === void 0) { asRootData = false; }
    if (entity instanceof model_js_2.Entity) {
        var ob = getEntityObserver(entity, true);
        if (entity.meta) {
            getObjectMetaObserver(entity.meta, true);
        }
        if (asRootData && ob) {
            ob.vmCount++;
        }
        return ob;
    }
    else {
        // TODO: Warn about attempting to observe non-entity?
    }
}
exports.observeEntity = observeEntity;
/**
 * Gets or creates an `EntityObserver` for the given entity
 * @param entity The entity begin observed
 * @param create If true, create the observer if it doesn't already exist
 */
function getEntityObserver(entity, create) {
    if (create === void 0) { create = false; }
    var EntityObserver = getEntityObserverConstructor();
    if ((0, helpers_1.hasOwnProperty)(entity, "__ob__") && (0, helpers_1.getProp)(entity, "__ob__") instanceof EntityObserver) {
        return (0, helpers_1.getProp)(entity, "__ob__");
    }
    else if (create) {
        // Mark the entity as "raw" so that Vue won't try to make it observable
        (0, vue_1.markRaw)(entity);
        return new EntityObserver(entity, true);
    }
    else {
        return null;
    }
}
exports.getEntityObserver = getEntityObserver;
// eslint-disable-next-line no-redeclare
var EntityObserverConstructor = null;
function getEntityObserverConstructor() {
    return EntityObserverConstructor || (EntityObserverConstructor = require("./entity-observer").EntityObserver);
}
exports.getEntityObserverConstructor = getEntityObserverConstructor;
/**
 * Gets or creates an `ObjectMetaObserver` for the given meta object
 * @param meta The object meta begin observed
 * @param create If true, create the observer if it doesn't already exist
 */
function getObjectMetaObserver(meta, create) {
    if (create === void 0) { create = false; }
    var ObjectMetaObserver = getObjectMetaObserverConstructor();
    if ((0, helpers_1.hasOwnProperty)(meta, "__ob__") && (0, helpers_1.getProp)(meta, "__ob__") instanceof ObjectMetaObserver) {
        return (0, helpers_1.getProp)(meta, "__ob__");
    }
    else if (create) {
        // Mark the object meta as "raw" so that Vue won't try to make it observable
        (0, vue_1.markRaw)(meta);
        return new ObjectMetaObserver(meta, true);
    }
    else {
        return null;
    }
}
exports.getObjectMetaObserver = getObjectMetaObserver;
// eslint-disable-next-line no-redeclare
var ObjectMetaObserverConstructor = null;
function getObjectMetaObserverConstructor() {
    return ObjectMetaObserverConstructor || (ObjectMetaObserverConstructor = require("./object-meta-observer").ObjectMetaObserver);
}
exports.getObjectMetaObserverConstructor = getObjectMetaObserverConstructor;
/**
 * Based on Vue's internal `observe()` function. Ensures that the given array
 * is observable and optionally notes that it is referenced by a component
 * @param array The array to observe
 * @param asRootData The array is referenced as a component's data
 */
function observeArray(array, asRootData) {
    if (asRootData === void 0) { asRootData = false; }
    if (Array.isArray(array)) {
        if (model_js_3.ObservableArray.isObservableArray(array)) {
            var ob = getArrayObserver(array, true);
            if (asRootData && ob) {
                ob.vmCount++;
            }
            return ob;
        }
        else {
            // TODO: Warn about attempting to observe non-observable array?
        }
    }
    else {
        // TODO: Warn about attempting to observe non-array?
    }
}
exports.observeArray = observeArray;
/**
 * Gets or creates an `ArrayObserver` for the given observable array
 * @param entity The entity begin observed
 * @param create If true, create the observer if it doesn't already exist
 */
function getArrayObserver(array, create) {
    if (create === void 0) { create = false; }
    var ArrayObserver = getArrayObserverConstructor();
    if ((0, helpers_1.hasOwnProperty)(array, "__ob__") && (0, helpers_1.getProp)(array, "__ob__") instanceof ArrayObserver) {
        return (0, helpers_1.getProp)(array, "__ob__");
    }
    else if (create) {
        // Mark the array as "raw" so that Vue won't try to make it observable
        (0, vue_1.markRaw)(array);
        return new ArrayObserver(array, true);
    }
    else {
        return null;
    }
}
exports.getArrayObserver = getArrayObserver;
// eslint-disable-next-line no-redeclare
var ArrayObserverConstructor = null;
function getArrayObserverConstructor() {
    return ArrayObserverConstructor || (ArrayObserverConstructor = require("./array-observer").ArrayObserver);
}
exports.getArrayObserverConstructor = getArrayObserverConstructor;
/**
 * Based on Vue's internals `dependArray()` function
 * @param array The child array to track as a dependency
 */
function dependChildArray(array) {
    var arrayObserver = observeArray(array);
    if (arrayObserver)
        arrayObserver.ensureObservable();
    for (var e, i = 0, l = array.length; i < l; i++) {
        e = array[i];
        if (e != null) {
            if (e instanceof model_js_2.Entity) {
                var observer = getEntityObserver(e, true);
                observer.ensureObservable();
                observer.dep.depend();
            }
            else if ((0, helpers_1.hasOwnProperty)(e, "__ob__")) {
                e.__ob__.dep.depend();
            }
            if (Array.isArray(e)) {
                dependChildArray(e);
            }
        }
    }
}
exports.dependChildArray = dependChildArray;
var vueCompatibleModels = [];
/**
 * Make sure that entities in the given model are observable by Vue
 * By default, entities would not be observable, since model properties
 * are added to the prototype, Vue will not detect them. So, we use a custom
 * observer that leverages model metadata to manage property access/change.
 * @param model The model to augment
 */
function makeEntitiesVueObservable(model) {
    if (!model || !(model instanceof model_js_1.Model)) {
        // TODO: Warn about missing or non-Model argument?
        return;
    }
    if (vueCompatibleModels.indexOf(model) >= 0 || model._entitiesAreVueObservable === true) {
        return;
    }
    model.entityRegistered.subscribe(function (args) {
        observeEntity(args.entity).ensureObservable();
    });
    // Make existing entities observable
    for (var _i = 0, _a = Object.keys(model.types); _i < _a.length; _i++) {
        var typeName = _a[_i];
        var type = model.types[typeName];
        type.known().forEach(function (entity) {
            observeEntity(entity).ensureObservable();
        });
    }
    vueCompatibleModels.push(model);
    model._entitiesAreVueObservable = true;
}
exports.makeEntitiesVueObservable = makeEntitiesVueObservable;
